export class WeekPlanEmployeeDTO {
    constructor(data) {
        this.id = data.id;
        this.organizationId = data.organizationId;
        this.userId = data.userId;
        this.userName=data.userName;
        this.email=data.email;
        this.calendarEmployees=(data.calendarEmployees || []).map(ce => new CalendarEmployeeDTO(ce));
    }
}

export class CalendarEmployeeDTO {
    constructor(data) {
        this.id = data.id;
        this.year = data.year; // year as numeric value
        this.weekCalendarNumber = data.weekCalendarNumber;
        
        this.dailyPlanEmployees = (data.dailyPlanEmployees || []).map(dp => new DailyPlanEmployeeDTO(dp));
        this.workTimeHours = data.workTimeHours;
        this.workTimeMinutes = data.workTimeMinutes;
        this.activate = data.activate;
    }
}

export class DailyPlanEmployeeDTO {
    constructor(data) {
        this.id = data.id;
        this.day = data.day;
        this.dayStatus = data.dayStatus; // numeric directly, unless you need an object
        this.comment = data.comment;
        // Include SubOrganisation properties
        this.subOrganisationId = data.subOrganisationId;
        this.subOrganisation = data.subOrganisation;
        this.workDurationEmployees = (data.workDurationEmployees || []).map(wd => new WorkDurationEmployeeDTO(wd));
    }
}

export class WorkDurationEmployeeDTO {
    constructor(data) {
        this.id = data.id;
        this.startTime = new Date(data.startTime);
        this.endTime = new Date(data.endTime);
    }
}
export class DayStatusDTO {
    constructor(status) {
        this.status = status; // Assuming status is a string or an object
    }
}




